export default {
  ENV: 'production',
  LOGIN_URL: 'https://api.zitat.zara.lol/user/login/',
  API_URL: 'https://api.zitat.zara.lol/api'
}
